import { render, staticRenderFns } from "./EstadoImpositivo.vue?vue&type=template&id=372389c9&"
import script from "./EstadoImpositivo.vue?vue&type=script&lang=js&"
export * from "./EstadoImpositivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports